import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M11.238 7.244v2.5q.001.244-.025.469c-.144 1.687-1.138 2.525-2.97 2.525h-.25a.5.5 0 0 0-.4.2l-.75 1c-.33.443-.868.443-1.2 0l-.75-1a.58.58 0 0 0-.4-.2h-.25c-1.993 0-2.993-.494-2.993-2.994v-2.5c0-1.831.844-2.825 2.525-2.969a4 4 0 0 1 .469-.025h4q2.992.002 2.994 2.994"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      d: "M13.737 4.744v2.5q-.001 2.754-2.525 2.969a4 4 0 0 0 .025-.47v-2.5q-.002-2.991-2.993-2.993h-4a4 4 0 0 0-.47.025C3.92 2.594 4.913 1.75 6.745 1.75h4q2.991.002 2.993 2.994Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.435 8.781h.005m-2.193 0h.006m-2.193 0h.005"
    }, null, -1)
  ]))]))
}
export default { render: render }